import React from 'react'
import Navbar from '../features/nav/Navbar'

export default function Unuthorized() {
  return (
    <Navbar> <div>Unauthorized</div></Navbar>
  )
}
